import { SET_SCROLL_CONTAINER_SCROLL } from '../constants/actionTypes';
export function setScrollContainerScroll(id, coords) {
    return {
        type: SET_SCROLL_CONTAINER_SCROLL,
        id: id,
        coords: coords,
    };
}
